module.exports = __webpack_public_path__ + "img/最佳朗读@2x.c51691ed.png";